'use strict';

var Params = function Params(fixedBarWidth) {
  return function (containerWidth, containerHeight) {
    var padding = {
      top: 10,
      bottom: 85,
      left: 65,
      right: 50
    };
    var width = fixedBarWidth;
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      yNumberOfTicks: 5,
      xAxisShift: 0,
      yAxisShift: -70,
      yAxisLabelShift: -30,
      xAxisLabelShift: -50,
      forceWidth: true
    };
  };
};
module.exports = Params;